<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <Mlogin />
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all">
                  <div class="title_left">{{ title }}</div>
                  <!-- <span class="spans">上一年度总{{Key=="ReadRank"?"下载":"浏览"}}量：{{Key=="ReadRank"?lastRead_Times:lastView_Times}}  &nbsp;&nbsp;&nbsp;&nbsp; 本年度总{{Key=="ReadRank"?"下载":"浏览"}}量：{{Key=="ReadRank"?Read_Times:View_Times}}</span> -->
                  <div class="title_more2">
                    <a href="/EN">Home</a>>{{ title }}
                  </div>
                  <div class="clearfix"></div>
                </div>
                <IssueArticleListControl
                  :List="newList"
                  :isindex="true"
                  :type="0"
                  :isycb="false"
                  :isdataa="false"
                  :isdatab="true"
                ></IssueArticleListControl>
                <commonpage
                  :count="count"
                  @pageSize="pageSize"
                  @pageindex="pageindex"
                  :index="paramas"
                ></commonpage>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl />
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import commonpage from "../components/CommonPage";
import IssueArticleListControl from "../components/IssueArticleListControl/IssueArticleListControl";
export default {
  inject: ["reload"],
  data() {
    return {
      Ishtml: true,
      newList: [],
      count: 0,
      Key: "",
      title: "",
      PageSize: 10,
      PageIndex: 0,
      Read_Times: 0,
      lastRead_Times: 0,
      View_Times: 0,
      lastView_Times: 0,
      paramas: {
        PageSize: 10,
        PageIndex: 0,
        IssueId: 0,
      },
    };
  },
  components: {
    commonpage,
    IssueArticleListControl,
  },
  updated() {
    this.$store.commit("getSize", this.PageSize);
  },
  mounted() {
    this.Key = this.$route.query.Key;
    console.log(this.Key);
    this._getListb(this.PageSize, this.PageIndex);
    this.getOAViewTJ();
  },
  watch: {
    $route(to, from) {
      if (to.query.Key !== from.query.Key) {
        if (this.$route.query) {
          this.Key = this.$route.query.Key;
          this._getListb(10, 0);
        } else {
          this.reload();
        }
      }
    },
  },
  methods: {
    _getListb(pageSize, PageIndex) {
      var time = new Date().getTime();
      this.paramsa = {
        PageSize: pageSize,
        PageIndex: PageIndex,
        Type: "Sort",
        Key: this.Key,
        src: time,
      };
      this.$store
        .dispatch("_getListb", this.paramsa)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.newList = res.data.Data;
            this.count = res.data.ItemCount;
            this.title = res.data.TitleEN;
            document.title = res.data.TitleEN;
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
    getOAViewTJ() {
      var data = [];
      var year = new Date().getFullYear();
      var lastyear = year - 1;
      this.$store
        .dispatch("_getOAViewTJ")
        .then((res) => {
          this.Read_Times = res.data.Data.CurrentRead;
          this.View_Times = res.data.Data.CurrentView;

          this.lastRead_Times = res.data.Data.LastyearRead;
          this.lastView_Times = res.data.Data.LastyearView;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pageSize(val) {
      this.PageSize = val;
      this._getListb(val, this.PageIndex);
    },
    pageindex(val) {
      this.PageIndex = val;
      this._getListb(this.PageSize, val);
      this.$store.commit("getIndex", this.PageIndex);
    },
  },
};
</script>

<style scoped>
.spans {
  color: #666;
  font-size: 12px;
  margin-left: 25px;
  font-weight: 500;
}
</style>
